/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Injectable } from '@angular/core';
import { IAddFittingPopupFacade } from '../../../../../data-access/src/lib/domain/facades-models/add-fitting-popup-facade-interface';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { InitializeSystemInfo, sendClosePopupAction, setManageModeAction } from '../toolbelt.actions';
import { selectManageMode } from '../tool-belt.selector';
import { SystemStateManager } from '../../../../../utils/src/lib/system-state-manager.service';
import { GlobalConstants } from '../../constants/global-constants';

@Injectable({ providedIn: 'root' })
export class AddFittingPopupFacade implements IAddFittingPopupFacade {
  constructor(public store: Store, private stateManager: SystemStateManager) {}

  public selectManageMode(): Observable<boolean> {
    return this.store.select(selectManageMode);
  }

  public InitializeSystemInfo() {
    this.store.dispatch(InitializeSystemInfo());
  }

  public setManageModeAction(value: boolean) {
    this.store.dispatch(setManageModeAction({ mode: value }));
  }

  public sendClosePopupAction() {
    this.stateManager.saveChanges(GlobalConstants.Fitting2Docked);
    this.store.dispatch(sendClosePopupAction());
  }

  public sendClosePopupActionForManageMode(mode: boolean) {
    this.stateManager.saveChanges(GlobalConstants.Manage2Fitting);
    this.store.dispatch(setManageModeAction({ mode: mode }));
  }
}
